export const LISTE_TYPE_FORMAT_PRESSE = {
  title: 'Liste des types de formats presse',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste des types de format presse',
  },
  actions: {
    add: 'Ajouter un type de format presse',
    search: 'Rechercher',
    edit: 'Modifier',
    delete: 'Supprimer',
    archiver: 'Archiver',
  },
  tab: {
    libelle: 'Libellé',
    code: 'Code',
  },
  childrow: {
    emplacement: 'Emplacement',
    surface: 'Surface',
    couleur: 'Couleur',
    sens: 'Sens',
    largeur: 'Largeur (mm)',
    hauteur: 'Hauteur (mm)',
  },
};

export const ADD_TYPE_FORMAT_PRESSE = {
  titleAdd: 'Ajouter un type de format presse',
  titleEdit: 'Modifier un type de format presse',
  breadcrumb: {
    racine: 'Accueil',
    parametrage: 'Paramétrage',
    liste: 'Liste des types de format presse',
  },
  actions: {
    addLigne: 'Ajouter une ligne',
  },
  information: {
    libelle: 'Libellé',
    code: 'Code',
    typeFormatPresseLignes: {
      emplacement: 'Emplacement',
      surface: 'Surface',
      couleur: 'Couleur',
      sens: 'Sens',
      largeur: 'Largeur (mm)',
      hauteur: 'Hauteur (mm)',
    },
  },
  success: {
    add: 'Le type de format presse a été ajouté avec succès.',
    edit: 'Le type de format presse a été modifié avec succès.',
  },
  sensType: {
    hauteur: 'Hauteur',
    bandeau: 'Bandeau',
  },
  error: {
    surface: 'Surface',
    emplacement: 'Emplacement',
    couleur: 'Couleur',
    sens: 'Sens',
    largeur: 'Largeur',
    hauteur: 'Hauteur',
    code: 'Code',
    codoLengthError: 'Le champs Code doit contenir entre 1 et 5 caractères',
  },
};
